import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Search } from "lucide-react";
import { api, fmt, fmtRange } from "@/lib/api";

const STATUS = {
  pending: { label: "طلب جديد", cls: "text-gold bg-gold/10" },
  approved: { label: "بانتظار العربون", cls: "text-blue-300 bg-blue-500/10" },
  receipt_uploaded: { label: "مراجعة الوصل", cls: "text-yellow-300 bg-yellow-500/10" },
  confirmed: { label: "مؤكد", cls: "text-green-300 bg-green-500/10" },
  cancelled: { label: "ملغى", cls: "text-red-300 bg-red-500/10" },
};

const FILTERS = [
  { key: "", label: "الكل" },
  { key: "pending", label: "طلبات جديدة" },
  { key: "approved", label: "بانتظار العربون" },
  { key: "receipt_uploaded", label: "مراجعة الوصل" },
  { key: "confirmed", label: "مؤكدة" },
  { key: "cancelled", label: "ملغاة" },
];

export default function Bookings() {
  const navigate = useNavigate();
  const [status, setStatus] = useState("");
  const [q, setQ] = useState("");

  const { data } = useQuery({
    queryKey: ["bookings", status, q],
    queryFn: async () => (await api.get("/admin/bookings", { params: { status: status || undefined, q: q || undefined } })).data,
    refetchInterval: 5000,
  });

  return (
    <div className="space-y-4" data-testid="bookings-page">
      <h1 className="font-display text-2xl">الحجوزات</h1>
      <div className="relative">
        <Search size={18} className="absolute top-1/2 -translate-y-1/2 start-3 text-muted2" />
        <input data-testid="bookings-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="ابحث بالاسم أو الهاتف أو رقم الحجز"
          className="w-full card-lux p-3 ps-10 bg-navy2 text-offwhite outline-none focus:ring-1 focus:ring-gold" />
      </div>
      <div className="flex gap-2 overflow-x-auto pb-1">
        {FILTERS.map((f) => (
          <button key={f.key} data-testid={`filter-${f.key || "all"}`} onClick={() => setStatus(f.key)}
            className={`px-4 py-2 rounded-full text-xs whitespace-nowrap transition-colors ${status === f.key ? "btn-gold" : "card-lux text-muted2"}`}>{f.label}</button>
        ))}
      </div>
      <div className="space-y-2">
        {(data || []).map((b) => (
          <button key={b.id} data-testid={`booking-item-${b.id}`} onClick={() => navigate(`/admin/booking/${b.id}`)}
            className="card-lux p-4 w-full flex items-center justify-between hover:bg-navy3/40 transition-colors text-start">
            <div>
              <div className="flex items-center gap-2">
                <p className="text-offwhite font-medium">{b.name}</p>
                {b.booking_number && <span className="text-xs gold-text">{b.booking_number}</span>}
              </div>
              <p className="text-xs text-muted2">{b.venue_name} · {b.date} · {fmtRange(b.start_time, b.end_time)} · {b.event_type} · {b.guests} ضيف</p>
            </div>
            <span className={`text-[11px] px-2.5 py-1 rounded-full ${STATUS[b.status]?.cls}`}>{STATUS[b.status]?.label}</span>
          </button>
        ))}
        {!data?.length && <p className="text-muted2/60 text-sm card-lux p-4">لا توجد حجوزات.</p>}
      </div>
    </div>
  );
}

export { STATUS };
